import MicroModal from 'micromodal'
import externalLinks from './_utils/externalLinks'
import deviceDetect from './_utils/deviceDetect'
import handleFlyoutMenu from './_components/handleFlyoutMenu'
import handleMobileMenu from './_components/handleMobileMenu'
import hideDisclaimerOnSubmit from './_components/hideDisclaimerOnSubmit'
import showHideMenu from './_components/showHideMenu'
import tabs from './_components/tabs'

MicroModal.init( {
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
} )

const { init: initTabs } = tabs()

externalLinks()
hideDisclaimerOnSubmit()
showHideMenu()
handleMobileMenu()
handleFlyoutMenu()
initTabs()
deviceDetect()